// import { apiClient } from "../api/ApiClient";

// class ProductService{

//     async getTopSellers(){
//         return apiClient.get("/api/analytics/products/top-sellers?limit=10");
//     }

//     async getProductsByFilter(filters){
//         return apiClient.get(`/api/products?${filters}`);
//     }

//     async getTopSellersV2() {
//         try {
//             const response = await apiClient.get('/api/products/top-sellers');
//             return response.data;
//         } catch (error) {
//             console.error('Error fetching top sellers:', error);
//             throw error;
//         }
//     }

//     async getProductsListWithFilters(params) {
//         try {
//             const response = await apiClient.get(`/api/products/list?${params}`);
//             return response.data;
//         } catch (error) {
//             console.error('Error fetching top sellers:', error);
//             throw error;
//         }
//     }

//     // Get variant details by IDs (for non-logged in users)
//     async getVariantsByIds(variantIds){
//       const response = await apiClient.post(
//         `/api/products/variants/by-ids`,
//          variantIds
//       );
//       return { success: true, data: response.data };
//     };

//     async getProductDetails(productId) {
//       try {
//           const response = await apiClient.get(`/api/products/${productId}/details`);
//           return response.data;
//       } catch (error) {
//           console.error('Error fetching product details:', error);
//           throw error;
//       }
//     }

//     async fetchTrendedProducts() {
//       try {
//           const response = await apiClient.get(`/api/products/trends`);
//           return response.data;
//       } catch (error) {
//           console.error('Error fetching trending products:', error);
//           throw error;
//       }
//     }

//     // async getAllColorsAndSizes() {
//     //     try {
//     //         const response = await apiClient.get(`/api/products/attributes`);
//     //         return response.data;
//     //     } catch (error) {
//     //         console.error('Error fetching colors and sizes:', error);
//     //         throw error;
//     //     }
//     // }

//     async getColorsAndSizesByFilters({ collectionId, categoryIds, subCategoryIds, brandIds }) {
//         const response = await apiClient.get('/api/products/attributes', {
//             params: {
//             collectionId,
//             categoryIds,
//             subCategoryIds,
//             brandIds
//             }
//         });
//         return response.data;
//     }

//     async getProductsList(pageSize, currentPage, filters = {}) {
//         try {
//             const params = new URLSearchParams({
//                 page: currentPage,
//                 size: pageSize,
//                 ...filters
//             });

//             const response = await apiClient.get(`/api/products/search/list?${params}`);
//             return response.data;
//         } catch (error) {
//             console.error('Error fetching products list:', error);
//             throw error;
//         }
//     }

// }

// export default new ProductService();

import { apiClient } from "../api/ApiClient";

class ProductService {
  async getTopSellers() {
    return apiClient.get("/api/analytics/products/top-sellers?limit=10");
  }

  async getProductsByFilter(filters) {
    return apiClient.get(`/api/products?${filters}`);
  }

  async getTopSellersV2() {
    try {
      const response = await apiClient.get("/api/products/top-sellers");
      return response.data;
    } catch (error) {
      console.error("Error fetching top sellers:", error);
      throw error;
    }
  }

  async getProductsListWithFilters(params) {
    try {
      const response = await apiClient.get(`/api/products/list?${params}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching products list with filters:", error);
      throw error;
    }
  }

  // Get variant details by IDs (for non-logged in users)
  async getVariantsByIds(variantIds) {
    const response = await apiClient.post(
      `/api/products/variants/by-ids`,
      variantIds,
    );
    return { success: true, data: response.data };
  }

  async getProductDetails(productId) {
    try {
      const response = await apiClient.get(
        `/api/products/${productId}/details`,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching product details:", error);
      throw error;
    }
  }

  async fetchTrendedProducts() {
    try {
      const response = await apiClient.get(`/api/products/trends`);
      return response.data;
    } catch (error) {
      console.error("Error fetching trending products:", error);
      throw error;
    }
  }

  async getColorsAndSizesByFilters({
    collectionId,
    categoryIds,
    subCategoryIds,
    brandIds,
  }) {
    const response = await apiClient.get("/api/products/attributes", {
      params: {
        collectionId,
        categoryIds,
        subCategoryIds,
        brandIds,
      },
    });
    return response.data;
  }

  async getProductsList(pageSize, currentPage, filters = {}) {
    try {
      const params = new URLSearchParams({
        page: currentPage,
        size: pageSize,
        ...filters,
      });
      const response = await apiClient.get(
        `/api/products/search/list?${params}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching products list:", error);
      throw error;
    }
  }

  // ── NEW: Get all collections + categories + brands for filter panels ────
  async getFilters(collectionId = null) {
    try {
      const params = {};
      if (collectionId) params.collectionId = collectionId;
      const response = await apiClient.get("/api/products/filters", { params });
      return response.data; // { collections, categories, subCategories, brands }
    } catch (error) {
      console.error("Error fetching product filters:", error);
      throw error;
    }
  }

  // ── NEW: Get categories that belong to a specific collection ───────────
  async getCategoriesByCollection(collectionId) {
    try {
      const response = await apiClient.get("/api/categories/", {
        params: { collectionId },
      });
      return response.data; // CategoryDTO[]
    } catch (error) {
      console.error("Error fetching categories by collection:", error);
      throw error;
    }
  }

  async getSaleProducts(params) {
    try {
      const response = await apiClient.get(
        `/api/products/sales/list?${params}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching sale products:", error);
      throw error;
    }
  }
}

export default new ProductService();
